import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import { Avatar, Col, message, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { FC, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const SharedAdvert:FC<{advert:any}> = ({advert}) => {
  const { Text } = Typography;
  const [isShowSuccess, setIsShowSuccess] = useState(false);

  const socialMediaPlatforms = [
    
    {
      name: "Whatsap",
      color: "#2ab53f",
      icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHrtP5Qi0VEY8h1Hv8s3Vuap0BQQn8trBO7g&s",
      shareUrl: (url: string) =>
        `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`,
    },
    {
      name: "Telegram",
      color: "#28a7e7",
      icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRpE6N5yajqla0qCeY-QjpIi_YwafQbU6HR3Q&s",
      shareUrl: (url: string) =>
        `https://t.me/share/url?url=${encodeURIComponent(url)}`,
    },
    {
      name: "Facebook",
      color: "#1977f2",
      icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGFKGkE0n-MIDhhhVId5GpfwSz5wcPvTJ_Zw&s",
      shareUrl: (url: string) =>
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    },
  ];

  useEffect(() => {
    if (isShowSuccess) {
      setTimeout(() => {
        setIsShowSuccess(false);
      }, 3000);
    }
  }, [isShowSuccess]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${window.location.origin}/detay?id=${advert?.id}`)
    message.success("Link Kopyalandı");
    setIsShowSuccess(true);
  };

  const currentUrl =`${window.location.origin}/detay?id=${advert?.id}`;

  return (
    <>
      <Col xs={24}>
        <Row gutter={[0, 20]}>
          <Col xs={24} className="!overflow-auto auto">
            <p className="!text-indigo-500 !text-nowrap">{currentUrl}</p>
          </Col>
          <Col xs={24}>
            <Row gutter={[20, 20]}>
              {socialMediaPlatforms.map((platform) => (
                <Col xs={24} lg={12} key={platform.name}>
                  <a
                    href={platform.shareUrl(currentUrl)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="!flex gap-2 items-center"
                  >
                    <Avatar
                      className="!w-[40px] !h-[40px] !rounded-full"
                      src={platform.icon}
                    />
                    <Text
                      className="!text-lg"
                      style={{ color: platform.color }}
                    >
                      {platform.name}
                    </Text>
                  </a>
                </Col>
              ))}
            </Row>
          </Col>
          <Col xs={24}>
            <MazakaButton
              icon={isShowSuccess ? <CheckOutlined /> : <CopyOutlined />}
              block
              className="!p-4 !bg-[#FFC502] !text-black"
              onClick={copyToClipboard}
            >
              Linki Kopyala
            </MazakaButton>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default SharedAdvert;
